<template>
  <div class="statistic-filter-container">
    <el-radio-group class="statistic-ul" v-model="value">
      <el-radio class="statistic-li" v-for="item in selectStatistics" :key="item.value" :label="item.value">
        <span>{{ item.title }}</span>
      </el-radio>
    </el-radio-group>
  </div>
</template>

<script>
import { selectStatistics } from '@/constant';
export default {
  data() {
    return {
      value: ''
    };
  },
  props: {
    item: {
      type: Object,
      required: true
    }
  },
  computed: {
    selectStatistics() {
      let arr = [];
      if (this.item.fieldDetail.type === 'num') {
        arr = [...selectStatistics];
      } else {
        arr = [...selectStatistics.slice(0, 1)];
      }
      return arr;
    }
  },
  created() {
    this.value = this.item.value || this.selectStatistics[0].value;
  },
  methods: {
    validateInfo() {
      const statisticItem = this.selectStatistics.find(item => item.value === this.value);
      return { ...statisticItem };
    }
  }
};
</script>

<style lang="scss" scoped>
.statistic-filter-container {
  .statistic-ul {
    padding: 15px 20px;

    .statistic-li {
      display: block;
      margin-top: 10px;

      &:first-child {
        margin-top: 0;
      }
    }
  }
}
</style>
